// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip } from '@locus-taxy/neo-ui';

const MaraOnlyTag = (): React.Node => {
    const { t } = useTranslation('platform');

    return (
        <Chip leftIcon="visibility_on" palette="neutral">
            {t('settings.common.maraOnly')}
        </Chip>
    );
};

export default MaraOnlyTag;
